import { MutationHookOptions } from '@apollo/client';
import { useApiMutation } from '@common/hooks';
import { downloadPolicy } from '@common/services';
import { IDownloadPolicyPayload, IDownloadPolicyResponse } from '@common/types';
import DataService from '@core/services/DataService';

const useDownloadPolicy = (
  options?: MutationHookOptions<IDownloadPolicyResponse, IDownloadPolicyPayload>
) => {
  const [downloadApi] = useApiMutation<
    IDownloadPolicyResponse,
    IDownloadPolicyPayload
  >(downloadPolicy, 'downloadPolicy', { withLoader: false }, options);

  const downloadPolicyFunction = async (
    variables?: IDownloadPolicyPayload
  ): Promise<void | null> => {
    try {
      const data = (await downloadApi(variables)).data.production
        ?.downloadPolicy;
      if (!data) return null;

      data.forEach((file) => {
        DataService.downloadBase64File(
          file.content,
          file.contentType,
          file.fileName
        );
      });
    } catch (err) {
      console.error('Error downloading policy', err);

      return null;
    }
  };

  return downloadPolicyFunction;
};

export { useDownloadPolicy };
